import React from "react";
import "./Informations.css"; // Ajouter des styles spécifiques si nécessaire
import SEO from "../SEO/SEO";

const Informations = () => {
  const information = [
    {
      title: "IMPORTANT",
      description: `
        You can contact us at +33 (0)6 68 16 08 42 from 06:30 am till 11:00 pm (Paris Time)`,
    },
    {
      title: "PRIVATE SHUTTLE (Information for an arrival at BVA / CDG)",
      description: `
        A minivan or break will wait for you at the "meeting point" in the baggage claim area.
        The driver will hold a sign saying "Welcome Service" with your name. 
        Please wait until the end of the designated pick-up period. 
        In case of flight delays, we will do our best to wait for you or send the next minibus as soon as possible. 
        However, this may result in unexpected delays connecting with ground transportation.`,
    },
    {
      title: "PRIVATE SHUTTLE (Information for a departure)",
      description: `
        Be ready to leave at the scheduled pick-up time, either in the hotel lobby 
        or in front of your main entrance. Please wait until the end of the designated pick-up period. 
        Confirm your reservation with the driver to avoid entering the wrong vehicle. 
        If heavy traffic causes delays, we will contact you.`,
    },
    {
      title: "SHARED SHUTTLE SERVICE (Information for an arrival at BVA / CDG)",
      description: `
        A minivan or break will wait for you at the "meeting point" in the baggage claim area. 
        The driver will hold a sign saying "Welcome Service" with your name. 
        Please wait until the end of the designated pick-up period. 
        On a shared transfer service, you will share your transfer with other passengers 
        arriving around the same time and traveling to the same destination. 
        A waiting period of 15-30 minutes may occur. 
        If heavy traffic delays your journey, we will contact you.`,
    },
    {
      title: "SHARED SHUTTLE SERVICE (Information for a departure)",
      description: `
        Be ready to leave at the scheduled pick-up time, either in the hotel lobby 
        or in front of your main entrance. Please wait until the end of the designated pick-up period. 
        Confirm your reservation with the driver to avoid entering the wrong vehicle. 
        On a shared transfer service, you will share your transfer with other passengers 
        traveling to the same destination. A waiting period of 15-30 minutes may occur. 
        If heavy traffic delays your journey, we will contact you.`,
    },
  ];
/*
    <section id="services" className="py-5">
      <div className="container text-center">
        <h2>Our Services</h2>

    <div className="container mt-5">
      <h1 className="text-center mb-4">Our Services</h1>
      <div className="row">
*/

  return (
<div>
    <SEO
    title="Information - RS Transports"
    description="Find all the essential details about RS Transports' private and shared shuttle services. Learn about arrival and departure procedures for Paris airports, including Beauvais (BVA) and Charles de Gaulle (CDG)."
    keywords="RS Transports, private shuttle, shared shuttle, airport transfers, Paris transportation, Beauvais BVA, Charles de Gaulle CDG, arrival procedures, departure procedures"
    />

      <section id="informations" className="py-5">
        <div className="container text-center">
        <h1 className="text-center mb-4">Information</h1>
            <div className="row mt-4">
            {information.map((info, index) => (
                <div className="col-md-12 mb-4" key={index}>
                <div className="card h-100">
                    <div className="">
                    <h2 className="card-title bg-black p-2">{info.title}</h2>
                    <p className="card-text">{info.description}</p>
                    </div>
                </div>
                </div>
            ))}
            </div>
        </div>
      </section>
</div>

  );
};

export default Informations;
